import type { IconData } from '@stacksjs/iconify-core'

export const plus: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8.9 6.9v-5a1 1 0 1 0-2 0v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default plus
